import { getImageOfNation, NATION_COLOR_LIST } from '@/constants/book';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

function NationIcon({
  code,
  name,
  index,
}: {
  code: string;
  name: string | undefined;
  index: number;
}) {
  const image = getImageOfNation(code);

  return image ? (
    <GlobalImage>
      <img src={image} alt={name} />
    </GlobalImage>
  ) : (
    <GlobalIcon index={index}>
      <Icon.Globe size={14} fillColor='#ffffff' />
    </GlobalIcon>
  );
}

const GlobalImage = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const GlobalIcon = styled.div<{ index: number }>`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ index }) => NATION_COLOR_LIST[index] || '#AF54FF'};
`;

export default NationIcon;
